import './ReverseIcon.css';

interface ReverseIconProps {
  size?: number;
  active?: boolean;
}

export function ReverseIcon({ size = 20, active = false }: ReverseIconProps) {
  return (
    <svg
      className={`reverse-icon ${active ? 'active' : ''}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12L9 6V10H21V14H9V18L3 12Z"
        fill="currentColor"
      />
      <path
        d="M3 12L9 6V10H21V14H9V18L3 12Z"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

